import type {CopilotChatMode} from '@github-ui/copilot-chat-types'
import {MaximizeIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import {memo, useState} from 'react'

import styles from './ChatImage.module.css'

export interface ChatImageProps {
  src: string | null
  alt?: string
  onClick?: React.MouseEventHandler
  useOverlay?: boolean
  squareView?: boolean
  mode: CopilotChatMode
}

const ChatImageUnmemoized = ({src, alt, onClick, useOverlay, mode, squareView}: ChatImageProps) => {
  const [isHovered, setIsHovered] = useState(false)

  if (!src) {
    return null
  }

  return (
    <div
      className={clsx(styles.chatImageAttachment, squareView ? styles.squareView : styles.fullView, {
        /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
        assistive: mode === 'assistive',
      })}
    >
      <img
        className={clsx(styles.userAttachedImage, squareView ? styles.squareView : styles.fullView)}
        src={src}
        alt={alt}
      />
      <a
        href={src}
        /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
        className={clsx(styles.overlay, {hovered: isHovered, [styles.squareView]: squareView})}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Open image thumbnail"
        target="_blank"
        rel="noreferrer"
      >
        {useOverlay && (
          <>
            <div className={styles.overlayScreen} />
            <MaximizeIcon className={styles.expandIcon} size={20} />
          </>
        )}
      </a>
    </div>
  )
}

export const ChatImage = memo(ChatImageUnmemoized)
